module.exports = __webpack_public_path__ + "assets/a755d98e43b425709107d6c42e378e84.png";